"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgComputer(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M22.213 2A1.79 1.79 0 0124 3.787v12.256a1.79 1.79 0 01-1.787 1.787l-9.448-.001v2.553l3.356.001a.766.766 0 01.104 1.525l-.104.007h-8.17a.766.766 0 01-.104-1.525l.104-.007 3.283-.001v-2.553H1.787a1.79 1.79 0 01-1.781-1.64L0 16.043V3.787A1.79 1.79 0 011.787 2zm0 1.532H1.787a.258.258 0 00-.255.255v12.256c0 .138.117.255.255.255h20.426a.258.258 0 00.255-.255V3.787a.258.258 0 00-.255-.255z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgComputer;
exports.default = _default;